const scroll = window.requestAnimationFrame || function(callback){ window.setTimeout(callback, 1000/60)};
const elementsToShow = document.querySelectorAll('.animate'); 
const offset = 200;

elementsToShow.forEach( el => {
  if ( el.getAttribute('data-delay') ) {
    el.style.transitionDelay = el.getAttribute('data-delay') + 'ms'
  }
  if ( el.getAttribute('data-duration') ) {
    el.style.transitionDuration = el.getAttribute('data-duration') + 'ms'
  }
})

function loop() {

    Array.prototype.forEach.call(elementsToShow, function(element){
      if (isElementInViewport(element)) {
        element.classList.add('is-visible');
      }
    });

    scroll(loop);
}


loop();


function isElementInViewport(el) {
  
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();
  const top = rect.top + offset
  const bottom = rect.bottom
  return (
    (top <= 0
      && bottom >= 0)
    ||
    (bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
    top <= (window.innerHeight || document.documentElement.clientHeight))
    ||
    (top >= 0 &&
      bottom <= (window.innerHeight || document.documentElement.clientHeight))
  );
}